import './styles/bolRating.scss';
import React, {MouseEventHandler} from 'react';
import {AwesomeIcon} from '@dvrd/dvr-controls';

import classNames from 'classnames';

interface Props {
    onClick?: MouseEventHandler;
    value: number;
    staticStars?: boolean;
    className?: string;
}

export default function BolRating(props: Props) {
    const {value, staticStars, className, onClick} = props;
    const fillPercentage: number = (100 / 5) * value;

    const fillStyle = {
        width: `${fillPercentage}%`
    };

    function renderStaticStar() {
        const _stars: React.ReactElement[] = [];
        for (let i: number = 0; i < value; i++) {
            _stars.push(<AwesomeIcon key={i} name='star' />);
        }
        return _stars;
    }

    return (
        <>
            {staticStars ? (
                <div className={classNames('static-star', className)} onClick={onClick}>
                    {renderStaticStar()}
                </div>
            ) : (
                <span className='score'>
                    <div className='score-wrap'>
                        <span className='stars-active' style={fillStyle}>
                            <AwesomeIcon name='star' />
                            <AwesomeIcon name='star' />
                            <AwesomeIcon name='star' />
                            <AwesomeIcon name='star' />
                            <AwesomeIcon name='star' />
                        </span>
                        <span className='stars-inactive'>
                            <AwesomeIcon name='star' />
                            <AwesomeIcon name='star' />
                            <AwesomeIcon name='star' />
                            <AwesomeIcon name='star' />
                            <AwesomeIcon name='star' />
                        </span>
                    </div>
                </span>
            )}
        </>
    );
}
